var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { r as registerInstance, c as createEvent, h, g as getElement } from './core-6f498fd9.js';
import { T as TextfieldType } from './textfield.type-6ef76b70.js';
var CsmTextfield = /** @class */ (function () {
    function class_1(hostRef) {
        registerInstance(this, hostRef);
        this.value = '';
        this.oldValue = '';
        console.warn('CSM-TEXTFIELD HAS BEEN DEPRECATED IN FAVOR OF CSM-INPUT');
        this.focusInput = this.focusInput.bind(this);
        this.csmChange = createEvent(this, "csmChange", 7);
        this.csmIconClick = createEvent(this, "csmIconClick", 7);
        this.csmKeydown = createEvent(this, "csmKeydown", 7);
        this.csmKeyup = createEvent(this, "csmKeyup", 7);
        this.csmFocus = createEvent(this, "csmFocus", 7);
        this.csmBlur = createEvent(this, "csmBlur", 7);
    }
    class_1.prototype.focusInput = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.textInput.focus();
                return [2 /*return*/];
            });
        });
    };
    class_1.prototype.onChange = function (event, force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            var input;
            return __generator(this, function (_a) {
                if (force || event.target.value !== this.oldValue) {
                    this.oldValue = this.value = event.target.value;
                    this.csmChange.emit(this.value);
                }
                input = this.host.querySelector('input');
                (input || this.host).blur();
                this.csmBlur.emit(event);
                return [2 /*return*/];
            });
        });
    };
    class_1.prototype.onKeyDown = function (event) {
        var keyCode = event.keyCode;
        var isMoveKeys = keyCode === 8 || keyCode === 9 || keyCode === 37 || keyCode === 39 || keyCode === 46; // Delete, Tab, Left, Right, Back delete
        if (this.type === TextfieldType.Number && !isMoveKeys && !+event.key && +event.key !== 0) {
            event.preventDefault();
            event.cancelBubble = true;
            return;
        }
        this.csmKeydown.emit(event);
    };
    class_1.prototype.onKeyUp = function (event) {
        if (event.code === 'Enter' || event.key === 'Enter') {
            this.onChange(event, true);
            return;
        }
        if (this.type === TextfieldType.Number &&
            !+event.key &&
            +event.key !== 0 &&
            event.code !== 'Backspace' &&
            event.code !== 'Delete' &&
            !event.key.startsWith('Arrow')) {
            event.preventDefault();
            event.cancelBubble = true;
            return;
        }
        event.value = event.target.value;
        this.host.setAttribute('value', event.target.value);
        this.csmKeyup.emit(event);
    };
    class_1.prototype.onIconClick = function (event, which) {
        var iconElement = event.path.find(function (i) { return i.tagName === 'CSM-ICON'; });
        this.csmIconClick.emit({ which: which, iconElement: iconElement });
    };
    class_1.prototype.onFocus = function (event) {
        this.csmFocus.emit(event);
    };
    class_1.prototype.componentWillLoad = function () {
        var nameAttr = this.host.attributes.getNamedItem('name');
        if (nameAttr) {
            this.host.attributes.removeNamedItem('name');
            this.name = nameAttr.value;
        }
    };
    class_1.prototype.render = function () {
        var _this = this;
        var inputType = this.type === TextfieldType.Number ? TextfieldType.Text : this.type;
        var ret = [];
        ret.push(h("input", Object.assign({ name: this.name, class: "csm-textfield__input", part: "textfield-input", placeholder: this.placeholder, type: inputType, value: this.value, onKeyDown: function (event) { return _this.onKeyDown(event); }, onKeyUp: function (event) { return _this.onKeyUp(event); }, onBlur: function (event) { return _this.onChange(event); }, onFocus: function (event) { return _this.onFocus(event); } }, { disabled: this.disabled }, { ref: function (el) { return (_this.textInput = el); } })));
        if (this.leftIcon && this.leftIcon.length) {
            ret.push(h("csm-icon", { class: 'csm-textfield__icon csm-textfield__icon-left' + (this.clickableIcon ? ' clickable' : ''), "size-m": true, name: this.leftIcon, onClick: function (e) { return _this.onIconClick(e, 'left'); }, part: "textfield-icon" }));
        }
        if (this.rightIcon && this.rightIcon.length) {
            ret.push(h("csm-icon", { class: 'csm-textfield__icon csm-textfield__icon-right' + (this.clickableIcon ? ' clickable' : ''), "size-m": true, name: this.rightIcon, onClick: function (e) { return _this.onIconClick(e, 'right'); } }));
        }
        return ret;
    };
    // @ts-ignore
    class_1.prototype.componentShouldUpdate = function (newVal, oldVal, propName) {
        if (!newVal) {
            return true;
        }
        return !(oldVal === newVal && propName === 'value');
    };
    Object.defineProperty(class_1.prototype, "host", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_1, "style", {
        get: function () { return "\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:400;src:url(../assets/fonts/ProximaNova-Regular.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Regular.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:600;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:700;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:900;src:url(../assets/fonts/ProximaNova-Black.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Black.woff) format(\"woff\")}\@font-face{font-family:CS-FontIcon-v19;src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb);src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb#iefix) format(\"embedded-opentype\"),url(../assets/icons/CS-FontIcon-v19.ttf?cz1hbb) format(\"truetype\"),url(../assets/icons/CS-FontIcon-v19.woff?cz1hbb) format(\"woff\"),url(../assets/icons/CS-FontIcon-v19.svg?cz1hbb#CS-FontIcon-v18) format(\"svg\");font-weight:400;font-style:normal;font-display:block}:root{font-family:Proxima Nova,sans-serif}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box;font-family:inherit}:host{display:block}.csm-textfield__icon:not(.clickable){pointer-events:none;color:#3c3d40}.csm-textfield__icon.clickable{cursor:pointer;color:#3c3d40}.csm-textfield__icon-left{position:absolute;float:right;margin:-26px 0 0 10px;display:block}.csm-textfield__icon-right{position:absolute;margin:10px 0 0 -24px}.csm-textfield__input{background:#fff;border:1px solid;border-color:#d1d6df;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:4px;padding:8px;height:36px;font-size:15px;line-height:20px;color:#3c3d40;width:100%}.csm-textfield__input::-webkit-inner-spin-button,.csm-textfield__input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.csm-textfield__inputinput[type=number]{-moz-appearance:textfield}.csm-textfield__input::-webkit-input-placeholder{color:rgba(0,0,0,.24)}.csm-textfield__input::-moz-placeholder{color:rgba(0,0,0,.24)}.csm-textfield__input:-ms-input-placeholder{color:rgba(0,0,0,.24)}.csm-textfield__input::-ms-input-placeholder{color:rgba(0,0,0,.24)}.csm-textfield__input::placeholder{color:rgba(0,0,0,.24)}.csm-textfield__input:placeholder-shown~.csm-textfield__icon{color:rgba(0,0,0,.24)}.csm-textfield__input:hover{border:1px solid;border-color:#a7abb2}.csm-textfield__input:focus{border:1px solid;border-color:#4b8ae7;outline:none}.csm-textfield__input:invalid{border:1px solid;border-color:#d94c62;outline:none}.csm-textfield__input:invalid~.csm-textfield__icon{color:#d94c62}:host([disabled]) .csm-textfield__input{border:1px solid;border-color:#e3e6ec;outline:none}:host([disabled]) .csm-textfield__icon{color:#e3e6ec}:host([error]) .csm-textfield__input{border:1px solid;border-color:#d94c62;outline:none}:host([error]) .csm-textfield__icon{color:#d94c62}:host([success]) .csm-textfield__input{border:1px solid;border-color:#24b397;outline:none}:host([success]) .csm-textfield__icon{color:#24b397}:host([left-icon]:not([left-icon=\"\"])) .csm-textfield__input{padding-left:36px}:host([right-icon]:not([righr-icon=\"\"])) .csm-textfield__input{padding-right:36px}"; },
        enumerable: true,
        configurable: true
    });
    return class_1;
}());
export { CsmTextfield as csm_textfield };
